import styled from 'foundations-theming/utils';
export const Text = styled.span.withConfig({
  displayName: "Text",
  componentId: "sc-980wkc-0"
})(["display:flex;justify-content:center;align-items:center;width:100%;height:36px;font-size:14px;letter-spacing:0.25px;font-weight:500;min-width:160px;"]);